const columnDataGrid = [
  // {
  //   dataField: 'pieceNumId',
  //   caption: 'Ключ УЕ',
  //   editorType: 'dxTextBox',
  //   groupItem: 1
  // },
  {
    dataField: 'qcId',
    caption: '№ СК',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'accountingDate',
    caption: 'Дата СК',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'cgId',
    caption: '№ партии',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'actualPieceId',
    caption: '№ УЕ',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'productGroupDescription',
    caption: 'Продукт',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'thick',
    caption: 'Толщина, мм',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'width',
    caption: 'Ширина, мм',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'length',
    caption: 'Длина, мм',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'weightNetto',
    caption: 'Вес нетто, т',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'weightBrutto',
    caption: 'Вес брутто, т',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'heatId',
    caption: '№ плавки',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'kolShtPart',
    caption: 'Количество труб в связке',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'pfrDescr',
    caption: 'Профилеразмер',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'sapId',
    caption: '№ УЭ SAP',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'qcShopDescr',
    caption: 'Цех-отправитель',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'customerName',
    caption: 'Грузополучатель рус.',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'customerNameEng',
    caption: 'Грузополучатель анг.',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'shiptoAddressSo',
    caption: 'Адрес получателя рус.',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'shiptoAddressEnSo',
    caption: 'Адрес получателя англ.',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'shiptoStationNameSo',
    caption: 'Ст.назначения',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'shiptoStationCodeSo',
    caption: 'Код станции назначения',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'shipmentModeRequirement',
    caption: 'Способ отгрузки',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'vehicleId',
    caption: '№ тс',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'shiptoRailwayNameSo',
    caption: 'ЖД назначения',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'knotPurposeSo',
    caption: 'Целевой узел',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'shippingPointNumId',
    caption: 'Пункт отправки',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'shippingPoint',
    caption: 'Пункт отправки',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'sposobUkladUpakovka',
    caption: 'Способ отгрузки',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'deliveryId',
    caption: 'Номер поставки',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'l4SoId',
    caption: '№ СЗ сист.',
    editorType: 'dxTextBox',
    groupItem: 3
  },
  {
    dataField: 'soDescrId',
    caption: '№ Заказа',
    editorType: 'dxTextBox',
    groupItem: 3
  },
  {
    dataField: 'soLineDescrId',
    caption: 'Позиция заказа',
    editorType: 'dxTextBox',
    groupItem: 3
  },
  {
    dataField: 'zzordOtsortConf',
    caption: 'Признак ОХ из заказа',
    editorType: 'dxTextBox',
    groupItem: 3
  },
  {
    dataField: 'planDatePps',
    caption: 'Плановая дата отгрузки с комбината',
    editorType: 'dxTextBox',
    groupItem: 3
  },
  {
    dataField: 'plannerNote',
    caption: 'Примечание',
    editorType: 'dxTextArea',
    groupItem: 3
  },
  {
    dataField: 'ordheadText',
    caption: 'Примечание менеджера SAP',
    editorType: 'dxTextArea',
    groupItem: 3
  },
  {
    dataField: 'okpoConsignee',
    caption: 'ОКПО Грузополучателя',
    editorType: 'dxTextBox',
    groupItem: 3
  },
  {
    dataField: 'tnglConsignee',
    caption: 'ТНГЛ Грузополучателя',
    editorType: 'dxTextBox',
    groupItem: 3
  },
  {
    dataField: 'contractNoLog',
    caption: 'Договор и наименование покупателя (для СМГС)',
    editorType: 'dxTextBox',
    groupItem: 3
  },
  {
    dataField: 'lprio',
    caption: 'Приоритет поставки',
    editorType: 'dxTextBox',
    groupItem: 3
  }
];

export default columnDataGrid;
